import { render, staticRenderFns } from "./ThanksFeedback.vue?vue&type=template&id=730edf0b&scoped=true&"
import script from "./ThanksFeedback.vue?vue&type=script&lang=js&"
export * from "./ThanksFeedback.vue?vue&type=script&lang=js&"
import style0 from "./ThanksFeedback.vue?vue&type=style&index=0&id=730edf0b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730edf0b",
  null
  
)

export default component.exports